import { forwardRef } from 'react';
import { cn } from '../../helper/classNames';

const Card = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'shadcn-card rounded-xl border border-gray-100 dark:border-transparent bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 shadow-sm',
        className,
      )}
      {...props}
    />
  ),
);
Card.displayName = 'Card';

export { Card };
